<template>
  <div>
    <div class="recommendation-section">
      <!-- SECTION INTRO TITLE -->
      <div class="section-intro" v-if="false">
        <div class="title color_text font-weight-bold">Recommendation</div>
        <div class="description color_ash font-11-5">
          Help identified students CatchUp with the class.
        </div>
      </div>

      <!-- RECOMMENDATION BLOCK -->
      <div class="recommendation-block rounded-5 white h-auto">
        <!-- TOP BLOCK -->
        <div class="top-block">
          <div
            class="d-flex justify-content-start align-items-start nowrap position-relative"
            v-if="report.topic_list"
          >
            <!-- AVATAR -->
            <div class="avatar avatar-square mr-2 mr-sm-3">
              <img
                v-lazy="
                  dynamicImg(`Math${Math.floor(Math.random() * 8 + 1)}.png`)
                "
                alt
                class="avatar-img"
              />
            </div>

            <!-- TITLE -->
            <div class="topic-name position-relative" @click="toggleTopicList">
              <div
                class="title font-14 color_ash position-relative pointer"
                style="top: 6px"
              >
                <template v-if="report.current_topic !== null">{{
                  report.current_topic.topic || "No topic selected..."
                }}</template>
                <template v-else>Empty topic list</template>
                <span
                  style="top: 2.5px"
                  class="icon-caret-down color_ash font-15 ml-3 position-relative"
                ></span>
              </div>
            </div>

            <div
              class="topic-dropdown brand_white_bg index-9"
              v-on-clickaway="onOuterDrop"
              v-if="show_topics"
            >
              <template v-if="report.topic_list">
                <template v-if="report.topic_list.length">
                  <div
                    v-on-clickaway="onInnerDrop"
                    class="topic"
                    :class="
                      topic.id === report.current_topic.id ? 'active' : null
                    "
                    v-for="(topic, index) in report.topic_list"
                    :key="index"
                    :id="topic.id"
                    @click="
                      $emit('update-topic', {
                        value: topic.id,
                        type: 'topic_id',
                      })
                    "
                  >
                    {{ topic.topic }}
                  </div>
                </template>
                <template v-else>
                  <div class="topic" style="width: 150px">Select topic</div>
                </template>
              </template>
              <template v-else>
                <div class="topic" style="width: 150px">No topic available</div>
              </template>
            </div>
          </div>
        </div>

        <!-- MID BLOCK -->
        <div class="mid-block">
          <div class="tabs w-100">
            <div
              class="tab tab-1 active"
              @click="changeView($event, 'struggling')"
            >
              Struggling
            </div>
            <div class="tab tab-2" @click="changeView($event, 'average')">
              Average
            </div>
            <div class="tab tab-3" @click="changeView($event, 'top')">
              Excelling
            </div>
          </div>

          <!-- COMPONENTS GOES HERE -->
          <transition name="fade" mode="out-in">
            <keep-alive>
              <StrugglingList
                v-if="in_view === 'StrugglingList'"
                :data="report.struggling_student"
                :subject="report.current_subject"
                :topic="report.current_topic"
                :students="students"
              ></StrugglingList>

              <AverageList
                v-else-if="in_view === 'AverageList'"
                :data="report.average_student"
                :topic="report.current_topic"
                :subject="report.current_subject"
                :students="students"
              ></AverageList>

              <TopList
                v-else-if="in_view === 'TopList'"
                :data="report.excellence_student"
                :topic="report.current_topic"
                :subject="report.current_subject"
                :students="students"
              ></TopList>
            </keep-alive>
          </transition>
          <!-- COMPONENTS GOES HERE -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StrugglingList from "@/components/classComps/report/StrugglingList";
import { mixin as clickaway } from "vue-clickaway";
import { union } from "lodash";

export default {
  name: "Recommendation",

  props: ["report", "loaded_view"],

  mixins: [clickaway],

  components: {
    StrugglingList,
    AverageList: () =>
      import(
        /* webpackChunkName: "ClassReport" */
        "@/components/classComps/report/AverageList"
      ),
    TopList: () =>
      import(
        /* webpackChunkName: "ClassReport" */
        "@/components/classComps/report/TopList"
      ),
  },

  computed: {
    students() {
      return union(
        this.report.struggling_student,
        this.report.average_student,
        this.report.excellence_student
      );
    },
  },

  watch: {
    loaded_view: {
      handler(newVal) {
        if (newVal) {
          this.in_view = this.loaded_view;
          let tabs = document.querySelectorAll(".tab");
          tabs.forEach((elm) => elm.classList.remove("active"));

          if (this.in_view === "StrugglingList")
            document.querySelector(".tab-1").classList.add("active");
          else if (this.in_view === "AverageList")
            document.querySelector(".tab-2").classList.add("active");
          else if (this.in_view === "TopList")
            document.querySelector(".tab-3").classList.add("active");
        }
      },
    },
  },

  data() {
    return {
      in_view: this.loaded_view,
      show_topics: false,

      average: [],
      struggling: [],
      excellence: [],
    };
  },

  methods: {
    changeView(event, view) {
      let tabs = document.querySelectorAll(".tab");
      tabs.forEach((elm) => elm.classList.remove("active"));

      if (view === "struggling") {
        this.in_view = "StrugglingList";
        event.target.classList.add("active");
      } else if (view === "average") {
        this.in_view = "AverageList";
        event.target.classList.add("active");
      } else if (view === "top") {
        this.in_view = "TopList";
        event.target.classList.add("active");
      }
    },

    toggleTopicList() {
      this.show_topics = !this.show_topics;
    },

    onOuterDrop() {
      this.show_topics = false;
    },

    onInnerDrop() {
      this.show_topics = false;
    },
  },
};
</script>

<style lang="scss">
.recommendation-section {
  margin-bottom: 60px;

  .section-intro {
    margin-bottom: 20px;

    .title {
      margin-bottom: 2px;
      font-size: 21px;
      line-height: 29px;

      @include breakpoint_max(md) {
        font-size: 19px;
      }

      @include breakpoint_max(sm) {
        font-size: 16.5px;
      }

      @include breakpoint_max(xs) {
        font-size: 15px;
      }
    }
  }

  // RECOMMENDATION BLOCK
  .recommendation-block {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);

    .top-block {
      padding: 28px 20px;

      @include breakpoint_max(sm) {
        padding: 18px 10px;
      }

      .topic-name {
        width: auto;
        .title {
          transition: all 0.3s ease-in-out;
          color: $color_text;

          @include breakpoint_max(sm) {
            top: 3.5px !important;
            font-size: 12px !important;
          }

          &:hover {
            color: darken($brand_accent, 15%);
          }

          span {
            @include breakpoint_max(sm) {
              top: 1px !important;
              left: -5px;
              font-size: 8px !important;
            }
          }
        }
      }

      .topic-dropdown {
        position: absolute;
        width: auto;
        left: 45px;
        top: 35px;
        border: 1px solid lighten($twitter-color, 10%);
        transition: all 0.3s ease-in-out;

        @include breakpoint_max(sm) {
          left: 0px;
          top: 30px;
        }

        .topic {
          font-size: 13px;
          padding: 4px 5px;
          color: $color_text;
          cursor: pointer;

          @include breakpoint_max(sm) {
            font-size: 12px;
          }

          @include breakpoint_max(xs) {
            font-size: 11.5px;
          }
          &:hover {
            background: $twitter-color;
            color: white;
          }
        }

        .active {
          background: $twitter-color;
          color: white;
        }
      }

      .topic-selector {
        width: auto !important;
        background: #fff;
        border: 0;

        &:focus {
          width: auto;
        }

        option {
          padding: 3px 5px;
        }
      }
    }

    .mid-block {
      padding-bottom: 30px;

      %tab-styling {
        &:after {
          position: absolute;
          content: "";
          left: 0;
          width: 100%;
          height: 2.5px;
          background: $brand_accent;
          bottom: -11px;
        }
      }

      .tabs {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-evenly;
        align-items: center;
        padding-bottom: 10px;
        margin-bottom: 5px;
        border-bottom: 1px solid $border_grey;

        .tab {
          position: relative;
          width: 33.33%;
          text-align: center;
          font-size: 14px;
          line-height: 19px;
          color: $border_grey_dark;
          cursor: pointer;
          transition: all 0.4s ease-in-out;

          @include breakpoint_max(lg) {
            font-size: 13px;
          }

          @include breakpoint_max(md) {
            font-size: 14px;
          }

          @include breakpoint_max(sm) {
            line-height: 14px;
            font-size: 12px;
          }

          @include breakpoint_max(xs) {
            line-height: 12px;
            font-size: 11.5px;
          }

          &:hover {
            color: $color_text;
            @extend %tab-styling;
          }
        }

        .active {
          color: $color_text;
          font-weight: 600;
          @extend %tab-styling;
        }
      }
    }
  }
}
</style>
